export const GetPaymentMethod = (str) => {
  if (str === 'bank_transfer') return 'Bank Transfer'
  else if (str === 'credit_card') return 'Credit Card'
  else if (str === 'paypal') return 'Paypal'
  else if (str === 'wallet') return 'Wallet'
  else return str
}
export const GetJSON = (str) => {
  if (str === undefined || str === '') return null
  else if (typeof str === 'string') return JSON.parse(str)
  else return str
}
export const sortObjectByKey = (object, key) => {
  object = object.sort((a, b) => {
    if (a.attribute_code === key) {
      return -1 // a comes before b
    }
    if (b.attribute_code === key) {
      return 1 // a comes after b
    }
    return 0 // no change in order
  })
  return object
}
export const validatePermission = (_key) => {
  const Permissions = JSON.parse(localStorage.getItem('PermissionList'))
  const UserPermissions =
    JSON.parse(localStorage.appState).permission === null
      ? []
      : JSON.parse(localStorage.appState).permission
  if (
    UserPermissions === null ||
    UserPermissions.length === 0 ||
    Permissions === null ||
    Permissions.length === 0
  ) {
    localStorage.removeItem('appState')
    window.location.href = '/login'
  }
  if (
    UserPermissions.map((x) => x.name).includes(
      Permissions.filter((x) => x.key === 'all-master').length > 0
        ? Permissions.filter((x) => x.key === 'all-master')[0].name
        : null
    )
  ) {
    return true
  }
  return UserPermissions.map((x) => x.name).includes(
    Permissions.filter((x) => x.key === _key).length > 0
      ? Permissions.filter((x) => x.key === _key)[0].name
      : null
  )
}
export const capitalizeString = (string) => {
  const splitStr = string.toLowerCase().split(' ')
  for (let i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  // Directly return the joined string
  return splitStr.join(' ')
}
export function groupBy(data, key) {
  return data.reduce((acc, cur) => {
    acc[cur[key]] = acc[cur[key]] || [] // Initialize if key doesn't exist
    acc[cur[key]].push(cur)
    return acc
  }, {})
}
export const setImage = (imagePath) => {
  return process.env.REACT_APP_S3_BUCKET_URL + imagePath
}
export const generateCombinations = (paramAttributes) => {
  const attributes = []
  Object.keys(paramAttributes).map((key) => {
    attributes[key] = paramAttributes[key].map((item) => item.id)
    return true
  })
  const keys = Object.keys(attributes)
  const combinations = []

  function backtrack(index, currentCombo) {
    if (index === keys.length) {
      combinations.push({ ...currentCombo })
      return
    }

    const attribute = keys[index]
    for (const option of attributes[attribute]) {
      currentCombo[attribute] = option
      backtrack(index + 1, currentCombo)
    }
  }

  backtrack(0, {})
  // const groupByProperty = Object.keys(combinations[0])[0]
  // combinations = groupBy(combinations, groupByProperty)
  return combinations
}
export const generateCombination = (attributes) => {
  const keys = Object.keys(attributes)
  const combinations = []

  function backtrack(index, currentCombo) {
    if (index === keys.length) {
      combinations.push({ ...currentCombo })
      return
    }

    const attribute = keys[index]
    for (const option of attributes[attribute]) {
      currentCombo[attribute] = option
      backtrack(index + 1, currentCombo)
    }
  }

  backtrack(0, {})
  return combinations
}
export const groupByProperty = (products, property) => {
  return products.reduce((acc, product) => {
    // Find the Clarity attribute in the product's attributes
    const attribute = product.attributes.find((attr) => attr.attribute_code === property)

    // If Clarity exists, group by the option_value (e.g., I3)
    if (attribute) {
      const groupByValue = attribute.option_id

      // If the groupByValue doesn't exist in the accumulator, initialize it
      if (!acc[groupByValue]) {
        acc[groupByValue] = []
      }

      // Push the product to the corresponding clarity group
      acc[groupByValue].push(product)
    }

    return acc
  }, {})
}
export const generateRandomString = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let result = ''

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }

  return result
}
export const isGroupByPropertyExist = (attributeData, property) => {
  let propertyCount = 0
  attributeData.map((attribute) => {
    if (attribute.attributes.filter((item) => item.attribute_code === property).length > 0)
      propertyCount++
    return true
  })
  if (propertyCount > 0) return true
  else return false
}
